<template>
  <div class="list_message">
    <div class="top">
      <span class="name">{{record.projectName}}</span>
      <div class="state">
        <span v-if="record.cooperationProgress == 2">意向</span>
        <span v-if="record.cooperationProgress == 3">签约</span>
        <span v-if="record.cooperationProgress == 4">落地</span>
        <span v-if="record.cooperationProgress == 5">完成</span>
      </div>
    </div>
    <div class="body">
      <p class="content">
        <span class="title">项目名称：</span>
        <span class="obj">{{record.projectName}}</span>
      </p>
      <p class="content">
        <span class="title">项目类别：</span>
        <span class="obj" v-if="record.contractCategory == 1">合同</span>
        <span class="obj" v-if="record.contractCategory == 2">协议</span>
        <span class="obj" v-if="record.contractCategory == 3">意向书</span>
        <span class="obj" v-if="record.contractCategory == 4">框架协议</span>
      </p>
      <p class="content">
        <span class="title">建设地点：</span>
        <span class="obj">{{getAllLocation[record.location]}}</span>
      </p>
      <p class="content">
        <span class="title">{{areaCode == 3 ? "签约外资金额（美元）：":"签约金额（亿元）："}}</span>
        <span class="obj">{{record.contractAmount ? record.contractAmount : '0'}}</span>
      </p>
      <p class="content">
        <span class="title">{{areaCode == 3 ? "到位外资金额（美元）：":"到位金额（亿元）："}}</span>
        <span class="obj">{{record.placeAmount ? record.placeAmount:'0'}}</span>
      </p>
    </div>
    <div class="foot">
       <!-- @click="$router.push({path: '/investment/activityDetails',query:{id:record.id, type:'investorParticularsProject'}})" -->
      <span @click="$router.push({path: '/investment/projectDetails',query:{id:record.id}})">查看详情</span>
      <img @click="$router.push({path: '/investment/projectDetails',query:{id:record.id}})" src="../../../assets/investment/jinru.png" alt="">
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  name: "listInvestorParticularsProject",
  components: {},
  props: {
    record:{}
    
  },
  data() {
    return {
      areaCode: '',
    };
  },
  computed: {
    ...mapGetters('investment', ['getAllLocation'])

  },
  watch: {},
  methods: {},
  created() {
    console.log(this.$store.state.investment.investorAreaCode, '6445465')
    this.areaCode = this.$store.state.investment.investorAreaCode
  },
  mounted() {},
};
</script>

<style lang="less" scoped>
.list_message {
    background: #FFFFFF;
    padding: 12px 20px;
    border-radius: 3px;
    margin-bottom: 12px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, .04);
    word-break:break-all;
    .top{
      display: flex;
      justify-content: flex-start;
      align-items: flex-start;
      .name{
        font-size: 16px;
        color: #333333;
        line-height: 22px;
        font-weight: bold;
      }
      .state{
        margin-left: 20px;
        white-space: nowrap;
        display: inline-block;
        font-size: 12px;
        line-height: 14px;
        background: rgba(34, 131, 230, 0.1);
        color: #2283E6;
        padding: 2px 4px;
        border-radius: 1px;
        span{
          display: inline-block;
          margin-top: 2px;
          transform: scale(0.8333);
        }
      }
      
    }
    .body{
      padding-top: 12px;
      border-bottom: 0.5px solid #EEEEEE;

      .content{
        margin-bottom: 12px;
        line-height: 17px;
        color: #333333;
      }
    }
    .foot{
      padding-top: 12px;
      
      span{
        display: inline-block;
        color: #36B374;
        line-height: 17px;
        font-size: 12px;
      }
      img{
        display: inline-block;
        width: 4px;
        height: 8px;
        margin-left: 5px;
      }
    }
}
</style>